var render = function render(){
  var _class, _class2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.notification] = true, _class[_vm.$style.notificationUnread] = _vm.notification.status !== 'READ', _class['cursor-pointer-hover'] = !_vm.isActionNotificationsHref(_vm.notification) || !_vm.isOpen, _class),
    on: {
      "click": function ($event) {
        return _vm.openNotification(_vm.notification);
      }
    }
  }, [_c('div', {
    class: (_class2 = {}, _class2[_vm.$style.notificationHeader] = true, _class2)
  }, [_c('p', {
    staticClass: "tag-text color-primary-blue"
  }, [_vm._v(_vm._s(_vm.notification.title))]), _c('p', {
    staticClass: "overline-text color-primary-blue",
    class: _vm.$style.notificationDate
  }, [_vm._v(" " + _vm._s(_vm.moment.unix(_vm.notification.createdAt).format('M/D/yyyy').toUpperCase()) + " ")]), _c('div', {
    class: _vm.$style.chevronContainer,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleOpen.apply(null, arguments);
      }
    }
  }, [_c('BaseIcon', {
    staticClass: "color-primary-blue",
    attrs: {
      "name": _vm.isOpen ? 'chevron-up' : 'chevron-down'
    }
  })], 1)]), _c('Transition', {
    attrs: {
      "name": "slide-y"
    }
  }, [_vm.isOpen ? _c('div', {
    class: _vm.$style.notificationBody
  }, [_c('p', {
    staticClass: "overline-text color-primary-blue"
  }, [_vm._v(_vm._s(_vm.notification.message))])]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }